// Have to set env var to deployed site url, since default env vars only point to generated urls
const normalizeBaseUrl = (value: string): string => {
  let normalized = value.trim();
  if (!normalized) {
    return normalized;
  }

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    try {
      const parsed = new URL(normalized);
      normalized = `${parsed.host}${parsed.pathname}`;
    } catch {
      // Fall through to basic normalization.
    }
  }

  normalized = normalized.replace(/\/+$/, '');
  return normalized;
};

export function getBaseUrl(): string {
  const raw = process.env.NEXT_PUBLIC_SITE_URL ?? `localhost:${process.env.PORT ?? 3000}`;
  return normalizeBaseUrl(raw);
}
